import React from 'react';
import DragNDropColumns, {
  EnumPosition,
} from 'src/components/DragNDropColumns';
// import WarningIcon from 'src/components/Icon/Warning';
// import css from './css.module.less';
import {
  //   Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import { Field } from 'src/components/RcForm';
//import { sectionProps } from 'src/tools/constant';
import { fields as fK } from 'src/tools/contentModulesFieldName';
//import ProductDisplayInRow from '@/src/components/DragRowDisplay/ProductDisplayInRowShort';
import { get } from 'lodash';
//import { ErrorDisplay2 } from 'src/constrains/SalesChannelPreviewPageComponents/CollapseErrors';
//import { checkResponsiveProductTab } from 'src/constrains/SalesChannelContent-Revamp/ModuleList/validator';
import {
  DOBKeyMapping,
  FiledNameKeyMapping,
} from '@/src/pages/CustomerDatabaseConfig/config';
import { randomNumber } from '@/src/tools/helper';
import { isNull } from 'lodash';
import FieldContainer from 'src/components/DragRowDisplay/DoubleRowsTextAndEditIcon';
import FieldModal from 'src/components/FieldModal';
import { EnumFieldType } from 'src/components/FieldModal/config';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';

const unDeletable = [EnumFieldType.Email];
const CustomerInformationFields = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    disabled,
    onSort,
    onDelete,
    // breakpoint,
    fieldsOptions = [],
    draggableId,
    onAdd,
    onModalConfirm,
  } = props;
  const [visible, setVisible] = React.useState(false);
  const [selectedField, setSelectedField] = React.useState<any>({});
  const [selectedIndex, setSelectedIndex] = React.useState(null);

  return (
    <Section
      {...{ size: 'small', bottomBorder: false, style: { padding: 0 } }}
      id={draggableId}>
      <Field name={[fK]}>
        {(p, m) => {
          const { value: fields = [], onChange } = p;
          const generateAvailableField = (currentField?) => {
            const currentOccupiedField = fields.map((i) => {
              return get(i, 'field.uuid');
            });
            const _currentOccupiedField = currentOccupiedField.filter(
              (i) => i !== currentField,
            );
            const ava = fieldsOptions.filter((i) => {
              const type = get(i, 'uuid');
              return !_currentOccupiedField.includes(type);
            }); // difference(types, _currentOccupiedField);
            return ava;
          };

          const fieldChildGenerate = (data, index) => {
            const { field, required, dateOfBirthFields } = data;
            console.log('dateOfBirthFields: ', dateOfBirthFields);

            const currentField = get(field, 'fieldType');
            const currentUuid = get(field, 'uuid');
            const name = get(field, 'name');
            const ava = generateAvailableField(currentUuid);
            const className = unDeletable.includes(currentField)
              ? css.fieldContainer
              : '';
            return (
              <FieldContainer
                disabled={disabled}
                title={`${getI18n(FiledNameKeyMapping[name])} ${
                  required
                    ? `(${getI18n('general.fieldModal.required_fields')})`
                    : ''
                }`}
                name={`${getI18n(FiledNameKeyMapping[name])} ${
                  (dateOfBirthFields || []).map((o) =>
                    getI18n(DOBKeyMapping[o]),
                  ) || ''
                }`}
                containerClassName={className}
                onClick={() => {
                  setSelectedField({ ...data, index, availableFields: ava });
                  setVisible(true);
                  setSelectedIndex(index);
                }}
              />
            );
          };

          const handleOnModalOk = (data) => {
            if (isNull(selectedIndex)) {
              if (onAdd) {
                onAdd(fields, onChange, {
                  draggableId: randomNumber(),
                  ...data,
                });
              }
            } else {
              if (onModalConfirm) {
                onModalConfirm(fields, onChange, data, selectedIndex);
              }
            }
            handleOnModalCancel();
          };

          const handleOnModalCancel = () => {
            setVisible(false);
            setSelectedIndex(null);
            setSelectedField({});
          };

          const handleItemOnSort = (obj) => {
            const { data } = obj;
            const { newIndex, oldIndex } = data || {};
            if (onSort) {
              onSort(fields, onChange, oldIndex, newIndex);
            }
          };
          const handleOnItemDelete = (index) => {
            if (onDelete) {
              onDelete(fields, onChange, index);
            }
          };

          return (
            <React.Fragment>
              {visible && (
                <FieldModal
                  title={getI18n('general.customerinformationfield')}
                  visible={visible}
                  {...selectedField}
                  onOk={handleOnModalOk}
                  onCancel={handleOnModalCancel}
                  placeholderRequired
                />
              )}
              <DragNDropColumns
                titleRightTextClassName={css.editContainer}
                hideTitle
                childGenerate={fieldChildGenerate}
                onDelete={disabled ? null : handleOnItemDelete}
                data={(fields || []).map((i) => {
                  const type = get(i, 'field.fieldType');
                  const item = {
                    ...i,
                    draggableId: i.draggableId || randomNumber(),
                  };
                  if (unDeletable.includes(type)) {
                    return { ...item, hideDelete: true };
                  }
                  return item;
                })}
                disabled={disabled}
                droppableId={`${draggableId}FieldDropArea`}
                onSort={handleItemOnSort}
                onAdd={() => {
                  setSelectedField({
                    availableFields: generateAvailableField(),
                  });
                  setVisible(true);
                }}
                hideAdd={generateAvailableField().length === 0 || disabled}
                addTextPosition={EnumPosition.bottom}
                addText={`+ ${getI18n('salesChannelContent.index.addField')}`}
              />
            </React.Fragment>
          );
        }}
      </Field>
    </Section>
  );
};
export default CustomerInformationFields;
